import { render, staticRenderFns } from "./header-slaktis.vue?vue&type=template&id=6df10b62&scoped=true"
import script from "./header-slaktis.vue?vue&type=script&lang=js"
export * from "./header-slaktis.vue?vue&type=script&lang=js"
import style0 from "./header-slaktis.vue?vue&type=style&index=0&id=6df10b62&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df10b62",
  null
  
)

export default component.exports